// @ts-nocheck
import { error, robotoRegular, scarpaGray800, white } from '@habitech/shared';
import styled from 'styled-components';

export const Wrapper = styled.div`
    background: ${white};
    border-radius: 10px;
    padding: 0;
    margin-bottom: 40px;
    .retention-tabs {
        margin: 0;
    }
    .container {
        padding: 0px;
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 24px 0px;
    }

    @media ${({ theme }) => theme.screenSizes.laptop} {
        margin: 0 auto;
        padding: 16px 24px;
    }
`;

export const Container = styled.div`
    form {
        margin: 48px 24px;
        max-width: 450px;
        display: grid;
        gap: 24px;
    }
    .toggle {
        display: flex;
    }
    
    .error-text {
        font-size: 12px;
        line-height: 14px;
        color: ${error};
        padding: 8px 0;
        font-family: ${robotoRegular};
        margin: 0;
    }
`;

export const WrapperButton = styled.div`
    max-width: 100%;
    display: flex;
    gap: 24px;
    margin-top: 24px;
    button {
        width: 100%;
        max-width: 200px;
        margin: auto;
    }
    &.checkboxs {
        flex-wrap: wrap;
    }
    &.leads {
        margin-bottom: 40px;
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        &.checkboxs {
            max-width: calc(100% + 350px);
            margin-right: -350px;
        }
    }
`;



export const ResponsiveWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 16px;
  .center {
    text-align: center;
  }
  @media (max-width: 600px) {
    padding: 4px;
  }
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  margin-bottom: 24px;
  position: relative;
  &.center td{
    text-align: center;
  }
  &.table-sticky {
    .thead-sticky {
        position: sticky;
        top: 0;
        background: white;
        box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 8px, rgba(0, 0, 0, 0.06) 0px 1.5px 4px;
        border: 1px solid rgb(224, 224, 224);
    }
  }
  h3 {
    margin-bottom: 24px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0 16px 0;
`;

export const TableCellStyled = styled.div`
    &.left {
        display: contents;
        td {
            text-align: left;
        }
    }
    &.center {
        display: contents;
        td {
            text-align: center;
            div {
                width: 100%;
            }
        }
    }
`


export const Title = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: ${scarpaGray800};
  text-align: left;
`;


export const InfoDropdown = styled.div`
  background: #f5f5f5;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.95em;
  color: #333;
  margin-top: 8px;
`;


export const TableWrapper = styled.div`
    max-height: 300px;
    overflow: auto;
    border: 1px solid #f5f5f5;
`
